/** The layout box an icon keeps when it is drawn at another size: a number for a square. */
export type Footprint = number | readonly [width: number, height: number];

/**
 * Margins that hand the difference between the drawn size and the footprint back to the layout.
 * Starfish artwork is padded on a 24 grid, so matching the ink of a tighter asset can take a bigger
 * drawing than the box it replaces; these keep the surrounding layout where it was.
 */
export const footprintMargin = (size: number, footprint?: Footprint): string | undefined => {
  if (footprint === undefined) return undefined;
  const [width, height] = typeof footprint === 'number' ? [footprint, footprint] : footprint;

  return `${(height - size) / 2}px ${(width - size) / 2}px`;
};
